// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"229":"48176f6e","243":"065600cd","495":"92453fd1","572":"80f59437"}[chunkId] + ".css";
};